import strings from "global/constants/StringConstants";

/**
 * Query string tagging a signer's journey from a completed signature to the
 * register page, e.g.
 * `?utm_source=sign_completed&utm_medium=internal&utm_campaign=post_sign_signup&utm_content=register_cta`
 *
 * Built as a relative search rather than an absolute
 * `https://sign.inkfree.app/register?…` link on purpose: the register page is a
 * route in this app, so navigating in-app keeps the SPA (and the signer's
 * name/email prefill state) intact and keeps the link working on localhost and
 * UAT, where the production host would 404.
 *
 * @param content One of the `UTM_CONTENT_*` constants — which CTA was clicked.
 */
export const postSignSignupSearch = (content: string): string =>
  `?${new URLSearchParams({
    utm_source: strings.UTM_SOURCE_SIGN_COMPLETED,
    utm_medium: strings.UTM_MEDIUM_INTERNAL,
    utm_campaign: strings.UTM_CAMPAIGN_POST_SIGN_SIGNUP,
    utm_content: content,
  }).toString()}`;
